import Sortable from 'sortablejs';

/**
 * checkAnlageClick
 * @param element
 */
window.checkAnlageClick = function(element) {
  document.querySelectorAll(element).forEach(el => el.addEventListener('click', event => {
    const isCheckbox = event.target.closest('div').classList.contains('form-field--checkbox');
    const isMove = event.target.closest('div').classList.contains('move');

    if (!isCheckbox && !isMove) {
      const row = event.target.closest('div.row-anlage');
      openAnlageDetails(Number(row.getAttribute('data-id')));
    }
  }));
};

/**
 * openAnlageDetails
 * @param id
 */
window.openAnlageDetails = function(id) {
  window.location = BASE_PATH + 'betriebsdaten/anlagenDetails/' + id;
};

/**
 * sortAnlagen
 */
window.sortAnlagen = function() {
  const tableAnlagen = document.getElementById('table-anlagen');

  Sortable.create(tableAnlagen, {
    handle: '.dragger',
    draggable: '.drag-row',
    animation: 150,
    easing: '',
    onEnd: function() {
      const elementIDs = [];
      Array.prototype.forEach.call(tableAnlagen.querySelectorAll('.drag-row'), function(element) {
        elementIDs.push(element.getAttribute('data-id'));
      });

      fetch(BASE_PATH + 'ajax/helper/additional/ajax.saveSorting', {
        method: 'POST',
        body: JSON.stringify({
          area: 'anlagen',
          elements: elementIDs,
        }),
      }).then(function(response) {
        return response.text();
      });
    },
  });
};

/**
 * Show/Hide Editmode
 * @param element
 * @param showEditMode
 */
window.editMode = function(element, showEditMode) {
  const form = document.querySelector(element).closest('form');
  if (showEditMode === true) {
    form.querySelectorAll('input, select, textarea, button').forEach(b => b.removeAttribute('disabled'));
    form.querySelectorAll('.tel-info-format').forEach(b => b.classList.remove('display-none'));

    document.getElementById('save-row').style.display = '';
    document.getElementById('edit-row').style.display = 'none';
  } else {
    form.querySelectorAll('input, select, textarea,  button:not(#edit-button)').forEach(b => b.setAttribute('disabled', 'disabled'));
    form.querySelectorAll('.tel-info-format').forEach(b => b.classList.add('display-none'));

    document.getElementById('save-row').style.display = 'none';
    document.getElementById('edit-row').style.display = '';
  }
};

/**
 * Anagrafische Daten aus Mitgliedschaft übernehmen
 */
window.importBetriebsdatenMitgliedData = function(type = 'betrieb') {
  if (type === 'betrieb') {
    editMode('#edit-row', true);

    if (document.getElementById('import-row') !== null) {
      document.getElementById('import-row').style.display = 'none';
    }
  }

  fetch(BASE_PATH + 'ajax/helper/betriebsdaten/ajax.getMitgliedData', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then(response => response.json()).then(data => {
    if (type === 'betrieb') {
      if (data['zip'] !== '') {
        document.getElementById('factory-plz').value = data['zip'];
      }
      if (data['place'] !== '') {
        document.getElementById('factory-ort').value = data['place'];
      }
      if (data['address'] !== '') {
        document.getElementById('factory-address').value = data['address'];
      }
      if (data['email'] !== '') {
        document.getElementById('factory-email').value = data['email'];
      }
      if (data['tel'] !== '') {
        document.getElementById('factory-telefon').value = data['tel'];
      }
      if (data['mobile'] !== '') {
        document.getElementById('factory-mobil').value = data['mobile'];
      }
      if (data['mwstr'] !== '') {
        document.getElementById('factory-mwstr').value = data['mwstr'];
      }
    } else if (type === 'betriebsleiter' || type === 'mitarbeiter') {
      if (data['firstname'] !== '') {
        document.getElementById('user-vorname').value = data['firstname'];
      }
      if (data['lastname'] !== '') {
        document.getElementById('user-nachname').value = data['lastname'];
      }
      if (data['firstname'] !== '' && data['lastname'] !== '') {
        const letterFirstname = data['firstname'].substring(0, 1);
        const letterLastname = data['lastname'].substring(0, 1);
        document.getElementById('user-kuerzel').value = letterFirstname + letterLastname;
      }
      if (data['address'] !== '') {
        document.getElementById('user-adresse').value = data['address'];
      }
      if (data['zip'] !== '') {
        document.getElementById('user-plz').value = data['zip'];
      }
      if (data['place'] !== '') {
        document.getElementById('user-ort').value = data['place'];
      }
    }
  }).catch(error => {
    console.error('Error:', error);
  });
};